export default {
  headerContent: {
    title: 'Atlas Sigorta Seyahat Sağlık Sigortası Ücretleri',
    slogan: "Seyahat Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'SEYAHAT SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Atlas Mutuel Sigorta Seyahat Sağlık Sigortası',
    description: {
      title: 'Atlas Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Seyahat sağlık sigortası, kişinin iş seyahati veya tatil gibi nedenlerle yurt dışına yapmış olduğu seyahatlerde karşılaşabileceği hastalık risklerine karşı güvence verir.',
        'Seyahat sağlık sigortası, bir seyahat sırasında beklenmedik bir tıbbi acil durum yaşarsanız sizi koruyabilir. Bu, kimsenin düşünmek istemediği bir konu olmasına rağmen, seçeneklerinizi bilmek önemlidir. ',
        'Aradığınız kapsama bağlı olarak, tek başına bir sağlık poliçesi seçebilir veya kapsamlı bir seyahat sigortası alabilirsiniz. Hangi politikanın en iyi olduğuna karar vermek, durumunuza, seyahat şartlarınıza ve sahip olabileceğiniz ek korumalara bağlıdır.'
      ]
    },
    subContent: {
      title: 'Atlas Sigorta Seyahat Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası genel şartları kapsamında verilen teminatlar; ',
          subList: [
            'Ani rahatsızlık ve hastalıklara ilişkin tıbbi tedavi teminatı',
            'Sigortalının tedavinin verilebileceği en yakın sağlık kuruluşuna seyahati veya nakli',
            'Sigortalının taburcu olduktan sonra ikametgah adresine nakli',
            'Vefat eden sigortalının naklidir.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Seyahat Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Seyahat Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Atlas Sigorta Seyahat Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title:
        'Atlas Sigorta Seyahat Sağlık Sigortası Kapsam Dışı Kalan Haller Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Bu Poliçe kapsamında talepte bulunan Sigortalının hileli hareketleri, ',
            'Sel, seylap, deprem, volkanik patlamalar, heyelan fırtına ve meteor düşmesi gibi doğal afetler sonucu ortaya çıkan zararlar, ',
            'Harp veya harp niteliğindeki harekat, ihtilal, isyan, ayaklanma ve bunlardan doğan iç kargaşalıklar, ',
            '3713 sayılı Terörle Mücadele Kanununda belirtilen terör eylemleri ve sabotaj ile bunları önlemek ve etkilerini azaltmak amacıyla yetkili organlar tarafından yapılan müdahaleler, ',
            'Nükleer rizikolar veya nükleer, biyolojik ve kimyasal silah kullanımı veya nükleer, biyolojik ve kimyasal maddelerin açığa çıkmasına neden olacak her türlü saldırı ve sabotaj, ',
            'Silahlı kuvvetler veya güvenlik kuvvetleri veya örgütlerinin harekatı, ',
            'Tehlikede bulunan kişileri ve malları kurtarmak hali müstesna, sigortalının kendisini bile bile ağır bir tehlikeye maruz bırakacak hareketlerde bulunması,',
            "Sigortalı'nın kasıtlı hareketleri, ",
            'Tıbbi reçete dışında alınan alkol, ilaçlar, zehirli maddeler uyuşturucular veya tıbbi ürünlerin gönüllü tüketimi ile ortaya çıkan hastalıklar veya patolojik durumlar, ',
            'Poliçenin geçerlilik tarihleri arasında, poliçe başlangıç tarihinden önce var olduğu, yetkili bir doktor tarafından tespit edilen tıbbi bir durum veya bu duruma bağlı olarak ortaya çıkan akut kriz, ',
            'Doğuştan olan hastalıklar (Gebelik esnasında oluşan veya genetik faktörlerden kaynaklanan hastalıklar), ',
            'İntihar veya intihar teşebbüsü, ',
            'Akıl hastalıkları, psikolojik rahatsızlıklar, salgın hastalıklar, ',
            'Aşağıdaki sporların yapılması: hangi türden olursa olsun her türlü yarış, ralli veya benzeri denemeler, olta balıkçılığı dışında av faaliyetleri, tüplü ve serbest derin dalışlar, umumi yolcu taşımacılığı yapmak amacıyla tasarlanmamış deniz araçlarıyla uluslararası sularda dolaşma, binicilik, dağcılık, atış talimleri, boks, ne türden olursa olsun güreş sporları, dövüşme sanatları, paraşütçülük, sıcak hava balonculuğu, serbest düşme, yamaç paraşütü ve genel olarak tehlikeli olduğu bilinen her türlü spor veya eğlence faaliyeti,',
            'Spor federasyonları veya benzeri organizasyonlar tarafından düzenlenen yarışlara veya turnuvalara katılma, ',
            'Bununla ilgili bir teminat verilmesi konusunda açıkça mutabakata varılmadığı sürece kayak, ',
            'Yolcu taşıma yetkisine sahip olmayan bir hava taşıtının ve helikopterlerin bir yolcu veya mürettebat sıfatıyla kullanılması, motorsiklet kullanımı, ',
            'Sigortanın kapsamına giren bir kaza neticesinde vuku bulmadığı taktirde suda boğulmalar kapsam dışıdır.'
          ]
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Seyahat Sağlık Sigortasından Kimler Yararlanabilir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortasını yurt dışına veya yurt içine yolculuk planlayan kişiler yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Seyahat Sağlık Sigortası Ne Zaman Başlar Ve Biter?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası poliçe başlangıç ve bitiş tarihleri poliçede yazmaktadır. Bu tarihler arasında poliçe geçerlidir. Poliçenin süresi sigortalının seyahat planına göre belirlenir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Seyahat Sağlık Sigortası Ne Zaman Yapılmalıdır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası seyahat başlamadan en geç bir gün önce yapılmalıdır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Seyahat Durumunda Seyahat Sağlık Sigortasını Yanımda Taşımalı Mıyım?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortanızı poliçe olarak taşımanıza gerek yoktur. Telefonunuzda veya mailinizde bulunması yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Seyahat Sağlık Sigortası En Az Kaç Günlük Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası en az 3 günlük olarak düzenlenmektedir. ',
          subList: null
        },
        {
          paragraph:
            'Seyahat sağlık sigortası ile kendinizi korumanın anahtarının bilgilendirilmek olduğunu unutmayın. Her bir avantajını ve istisnasını tam olarak anlamak için bir satın alma işlemi yapmadan önce her zaman politikanın tamamını okuyun. Bir politika hakkında sorularınız varsa, uzmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Seyahat Sağlık Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Bir politika için alışveriş yaptığınızda çok çeşitli seyahat koruma planları bulacaksınız. Tipik olarak, seyahat sigortası, çeşitli kapsamları içeren kapsamlı bir plan olarak bilinen bir paket olarak satılır.',
          subList: null
        },
        {
          paragraph:
            'Yaklaşan bir seyahat için seyahat sigortası yapmayı düşündüğünüzde, seyahatinizin bazı bileşenlerinin zaten kapsanmış olabileceğini bilmekten mutluluk duyacaksınız.',
          subList: null
        },
        {
          paragraph:
            'Alokasko olarak tüm sigorta ihtiyaçlarınıza cevap verebilmek için uzman kadromuz ile buradayız. Online seyahat sağlık sigortası fiyatını sitemizden kolaylıkla alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Seyahat Sağlık Sigortası Kaç Gün Geçerlidir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası sigortalının talebine göre yapılmaktadır. En az 3 gün olarak düzenlenebilen bu sigorta 1 yıllık da düzenlenebilmektedir. Planın kaç gün geçerli olacağı belirteceğiniz gidiş – dönüş tarihleri arasıdır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Kaza ve Hastalık Durumlarında Atlas Sigorta Seyahat Sağlık Sigortası Nasıl Kullanılır?',
      content: [
        {
          paragraph:
            'Kaza veya hastalık durumunda yapmanız gereken öncelikli adım sigorta şirketinin anlaşmalı hastanesine giderek seyahat sağlık sigortanız olduğunu bildirmektedir. ',
          subList: null
        },
        {
          paragraph:
            'Bildirmeniz sonucunda gerekli tedavi ve tetkiklerden poliçe limitleri dâhilinde yararlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Seyahat Sağlık Sigortası Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası hesaplaması seyahat edilecek ülke bilgileri, seyahat süresi ve sigortalanmak isteyen kişinin bilgileri doğrultusunda hesaplanmaktadır. ',
          subList: null
        },
        {
          paragraph:
            'İhtiyaçlarınıza ve istediğiniz fiyata özelleştirilmiş bir poliçe bulmak için en iyi seçeneğiniz teklif alarak primi hesaplamaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası Prim Ödemesi Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası prim ödemesini kredi kartınızdan veya nakit olarak yapabilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Online Seyahat Sağlık Sigortası Almak Avantajlı Mı?',
      content: [
        {
          paragraph:
            'İnternetten online seyahat sağlık sigortası satın almak avantajlıdır. En ucuz seyahat sağlık sigortası planını bulmanızı sağlarken, sunulan teminatlardan da en doğru şekilde yararlanabilmenizi sağlar.',
          subList: null
        },
        {
          paragraph:
            'Fiyat teklifi aldığınızda uzmanlarımız size tam kapsamlı bilgi vererek, ince ayrıntıları anlatır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Online Seyahat Sağlık Sigortası Aldım, Seyahatimi Ertelemem Gerekti Ne Yapmalıyım?',
      content: [
        {
          paragraph:
            'Planladığınız seyahat kapsamında satın aldığınız sigorta poliçesini iptal etmeniz mümkündür. Seyahatiniz belli başlı sebeplerden dolayı ertelenmişse sigorta danışmanlarımızı arayarak iptal işlemi yaptırabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Seyahat Sağlık Sigortası İptali Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası satın alan kişi, seyahate gidemediği durumda poliçe başlangıç tarihinden en geç 24 saat önce haber vermek ve poliçeyi sigorta şirketine iade etmek kaydıyla poliçesini iptal ettirerek, ödediği sigorta primini geri alır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Seyahat Sağlık Sigortası Ücretleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası sigortalı bilgileri ve poliçe kapsamına göre belirlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Seyahat Sağlık Sigortası Fiyatı Ne Kadar?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası fiyatları; şirket politikalarına, sigortalı bilgilerine ve seyahat edilecek ülkeye göre değişmektedir.',
          subList: null
        },
        {
          paragraph:
            'Seyahat sağlık sigortası fiyatı almak isteyen müşterilerimiz alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan uzman danışmanımızla iletişime geçebilir.',
          subList: null
        }
      ]
    }
  ]
}
